module.exports = __webpack_public_path__ + "img/pre-check.fef3b1ec.8ef2e062.svg";